import { gql } from "@apollo/client";

export const ADD_LUGGAGE_TO_TRIP = gql`
    mutation addLuggageToTrip($luggage_details: LuggageToTripInput!) {
        addLuggageToTrip(luggage_details: $luggage_details) {
            code
            success
            message
        }
    }
`

export const ENABLE_DISABLE_LUGGAGE_IN_TRIP = gql`
    mutation enableDisableLuggageInTrip($trip_luggage_id: NonEmptyString!, $isactive: Boolean!) {
        enableDisableLuggageInTrip(trip_luggage_id: $trip_luggage_id, isactive: $isactive) {
            code
            success
            message
        }
    }
`